import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 place-items-center sm:p-4 h-full" }
const _hoisted_2 = { class: "flex flex-col sm:w-3/4 w-full gap-4" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-semibold" }, "Contrato de inversión", -1)
const _hoisted_5 = { class: "flex flex-col sm:flex-row sm:items-center gap-8" }
const _hoisted_6 = { class: "flex flex-row gap-2" }
const _hoisted_7 = { class: "flex flex-col md:flex-row gap-4 s:items-center" }
const _hoisted_8 = { class: "relative flex flex-row items-center gap-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap" }, "Fecha de inicio", -1)
const _hoisted_10 = { class: "relative flex flex-row items-center gap-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "whitespace-nowrap" }, "Fecha de término", -1)
const _hoisted_12 = { class: "flex flex-col rounded-md shadow-lg overflow-auto gap-4" }
const _hoisted_13 = { class: "border-collapse mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("thead", { class: "" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 py-4 text-left font-semibold border-b border-gray-300" }, " Tipo "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 py-4 text-center font-semibold border-b border-gray-300" }, " Fecha de inicio "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 py-4 text-center font-semibold border-b border-gray-300" }, " Fecha de término "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-8 py-4 text-center font-semibold border-b border-gray-300" }, " Acción ")
  ])
], -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "px-8 py-4 text-left font-gray-800" }
const _hoisted_17 = { class: "px-8 py-4 text-center font-gray-800" }
const _hoisted_18 = { class: "px-8 py-4 text-center font-gray-800" }
const _hoisted_19 = { class: "grid grid-cols-5 px-8 py-4 text-left text-gray-800" }

import { watch, ref, onMounted } from "vue";
import { storeToRefs } from "pinia";
import { useRoute } from "vue-router";

import { useContractStore } from "@/stores/contract";

import PaginationControl from "@/components/atoms/PaginationControl.vue";
import NewContractModal from "@/components/organisms/NewContractModal.vue";
import EditContractModal from "@/components/organisms/EditContractModal.vue";
import ShowCommentModal from "@/components/organisms/ShowCommentModal.vue";

import Swal from "sweetalert2";
import { reformatDate } from "@/services/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'InvestmentContractsView',
  setup(__props) {

const route = useRoute();
const investmentId = ref(+route.params.id);

const newContractModal = ref<boolean>(false);

const selectedContractId = ref<number>(0);
const editContractModal = ref<boolean>(false);
const showCommentModal = ref<boolean>(false);

const selectedComment = ref<string>("");

const contractStore = useContractStore();
const {
  filter,
  pagination,
  createResponse,
  deleteResponse,
  updateResponse,
  contractList,
} = storeToRefs(contractStore);

const handleDeleteContract = async (contractId: number) => {
  Swal.fire({
    title: `¿Estás seguro de eliminar el contrato N° ${contractId}?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Eliminar",
    cancelButtonText: "Cancelar",
    customClass: {
      actions: "my-actions",
      cancelButton: "rounded-full bg-gray-300 text-white",
      confirmButton: "rounded-full bg-green-600 text-white",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      contractStore.deleteContract(contractId);
    }
  });
};

const handleDownload = async (contractId: number) => {
  contractStore.downloadContract(contractId);
};
const handleFilter = async (type: string) => {
  if (filter.value.type == "") {
    filter.value.type = type;
  } else {
    filter.value.type = "";
  }
  pagination.value.page = 1;

  contractStore.fetchContracts(investmentId.value);
};

const handleSetPage = async (page: number) => {
  pagination.value.page = page;
  await contractStore.fetchContracts(investmentId.value);
};

watch(deleteResponse, () => {
  if (deleteResponse.value.success) {
    Swal.fire("¡Éxito!", "Contrato eliminado exitosamente.", "success");
  } else {
    Swal.fire("Error", "Oops, tuvimos un problema.", "error");
  }
  contractStore.fetchContracts(investmentId.value);
});

watch(updateResponse, () => {
  contractStore.fetchContracts(investmentId.value);
});

watch(createResponse, () => {
  contractStore.fetchContracts(investmentId.value);
});

onMounted(() => {
  // Fetch contracts
  contractStore.fetchContracts(investmentId.value);
});

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => (newContractModal.value = true)),
          class: "flex flex-row items-center px-4 py-2 rounded-full bg-green-700 shadow-lg text-white justify-center font-medium text-sm hover:scale-110 transition-all"
        }, " Agregar nuevo contrato ")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass([
              _unref(filter).type == 'RENT'
                ? 'border-2 border-light-green text-white shadow-md bg-light-green'
                : '',
              'rounded-full px-4 py-1.5 border-2 font-semibold border-[#5E9bb441] text-[#5E9bb441] cursor-pointer',
            ]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleFilter('RENT')))
          }, " Arriendo ", 2),
          _createElementVNode("div", {
            class: _normalizeClass([
              _unref(filter).type == 'PURCHASE_SALE'
                ? 'border-2 border-light-green text-white shadow-md bg-light-green'
                : '',
              'rounded-full px-4 py-1.5 border-2 font-semibold border-[#5E9bb441] text-[#5E9bb441] cursor-pointer',
            ]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleFilter('PURCHASE_SALE')))
          }, " Compra ", 2),
          _createElementVNode("div", {
            class: _normalizeClass([
              _unref(filter).type == 'SALE'
                ? 'border-2 border-light-green text-white shadow-md bg-light-green'
                : '',
              'rounded-full px-4 py-1.5 border-2 font-semibold border-[#5E9bb441] text-[#5E9bb441] cursor-pointer',
            ]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleFilter('SALE')))
          }, " Venta ", 2),
          _createElementVNode("div", {
            class: _normalizeClass([
              _unref(filter).type == 'RENT_PURCHASE_SALE'
                ? 'border-2 border-light-green text-white shadow-md bg-light-green'
                : '',
              'rounded-full whitespace-nowrap px-4 py-1.5 border-2 font-semibold border-[#5E9bb441] text-[#5E9bb441] cursor-pointer',
            ]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (handleFilter('RENT_PURCHASE_SALE')))
          }, " Arriendo y/o compra ", 2)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_Datepicker, {
              modelValue: _unref(filter).start_date,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(filter).start_date) = $event)),
              "teleport-center": "",
              "input-class-name": "newcalssinput",
              "enable-time-picker": false,
              cancelText: 'Cancelar',
              selectText: 'Seleccionar'
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_Datepicker, {
              modelValue: _unref(filter).end_date,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(filter).end_date) = $event)),
              "teleport-center": "",
              "input-class-name": "newcalssinput",
              "enable-time-picker": false,
              "min-date": _unref(filter).start_date,
              cancelText: 'Cancelar',
              selectText: 'Seleccionar'
            }, null, 8, ["modelValue", "min-date"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("table", _hoisted_13, [
          _hoisted_14,
          (_unref(contractList) && _unref(contractList).length > 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(contractList), (contract) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: contract.id
                  }, [
                    _createElementVNode("td", _hoisted_16, _toDisplayString(_unref(contractStore).getContractType(contract.type) ?? "-"), 1),
                    _createElementVNode("td", _hoisted_17, _toDisplayString(contract.startDate ? _unref(reformatDate)(contract.startDate) : "-"), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(contract.endDate ? _unref(reformatDate)(contract.endDate) : "-"), 1),
                    _createElementVNode("td", _hoisted_19, [
                      _createElementVNode("div", {
                        class: _normalizeClass([
                    contract.comment ? 'text-gray-800' : 'text-gray-300',
                    'hover:scale-110 hover:cursor-pointer transition-all',
                  ])
                      }, [
                        _createVNode(_component_mdicon, {
                          onClick: 
                      () => {
                        if (contract.comment) {
                          selectedComment.value = contract.comment;
                          showCommentModal.value = true;
                        }
                      }
                    ,
                          name: "eye"
                        }, null, 8, ["onClick"])
                      ], 2),
                      _createVNode(_component_mdicon, {
                        class: "hover:scale-110 hover:cursor-pointer transition-all",
                        onClick: ($event: any) => (handleDownload(contract.id)),
                        name: "file-download"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_mdicon, {
                        class: "hover:scale-110 hover:cursor-pointer transition-all",
                        onClick: 
                    () => {
                      selectedContractId.value = contract.id;
                      editContractModal.value = true;
                    }
                  ,
                        name: "pencil"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_mdicon, {
                        class: "hover:scale-110 hover:cursor-pointer transition-all",
                        onClick: ($event: any) => (handleDeleteContract(contract.id)),
                        name: "delete"
                      }, null, 8, ["onClick"]),
                      _createVNode(_component_mdicon, {
                        class: "hover:scale-110 hover:cursor-pointer transition-all",
                        onClick: 
                    () =>
                      _ctx.$router.push({
                        name: 'investmentContractAlerts',
                        params: { id: contract.id },
                      })
                  ,
                        name: "bell"
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(PaginationControl, {
        selectedPage: _unref(pagination).page,
        perPage: _unref(pagination).per_page,
        totalPages: _unref(pagination).total_pages,
        onSetPage: handleSetPage
      }, null, 8, ["selectedPage", "perPage", "totalPages"])
    ]),
    _createVNode(NewContractModal, {
      visible: newContractModal.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = () => (newContractModal.value = !newContractModal.value))
    }, null, 8, ["visible"]),
    _createVNode(EditContractModal, {
      visible: editContractModal.value,
      contractId: selectedContractId.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = () => (editContractModal.value = !editContractModal.value))
    }, null, 8, ["visible", "contractId"]),
    _createVNode(ShowCommentModal, {
      visible: showCommentModal.value,
      comment: selectedComment.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = () => (showCommentModal.value = !showCommentModal.value))
    }, null, 8, ["visible", "comment"])
  ]))
}
}

})